__turbopack_context__.v({
  "actions": "FileUpload-module__M3Rxiq__actions",
  "container": "FileUpload-module__M3Rxiq__container",
  "displayField": "FileUpload-module__M3Rxiq__displayField",
  "editorial": "FileUpload-module__M3Rxiq__editorial",
  "editorialActions": "FileUpload-module__M3Rxiq__editorialActions",
  "editorialBrowseButton": "FileUpload-module__M3Rxiq__editorialBrowseButton",
  "editorialClearButton": "FileUpload-module__M3Rxiq__editorialClearButton",
  "hiddenInput": "FileUpload-module__M3Rxiq__hiddenInput",
});
